export const alert = { // Modulo notifiche
  namespaced: true,
  state: {
    snackbars: []
  },
  actions: {
    showSnackbar ({ commit }, snackbar) {
      snackbar.showing = true
      snackbar.timeout = 6000
      snackbar.color = snackbar.color || 'success'
      commit('setSnackbar', snackbar)
    }
  },
  mutations: {
    setSnackbar (state, snackbar) {
      state.snackbars = state.snackbars.concat(snackbar)
    }
  }
}
